<div class="notes" *ngFor="let item of thread.cp_message">
  <p class="header-item date">
    Date:
    <span class="value">{{
      item.created_at | date : "dd/MM/yyyy HH:mm:ss"
    }}</span>
  </p>

  <div class="content" [innerHTML]="item.value"></div>
</div>
<div
  class="advanced-chat-input"
  *ngIf="sendField === 'advanced' && thread.open_for_replies"
>
  <app-input-html
    [(ngModel)]="message"
    label=""
    placeholder="Type a message"
    name="message"
    type="text"
  ></app-input-html>

  <div class="action-btns">
    <button class="action-btn close" (click)="closeThread()">
      {{"Close thread" | translate}}
    </button>
    <button
      class="action-btn send"
      [disabled]="loadingSendMessage"
      (click)="sendMessage()"
    >
      Send Message
    </button>
  </div>
</div>
